export const PASSWORD_REQUIREMENTS = [
  {
    key: "minLength",
    label: "At least 8 characters",
    test: (password: string) => password.length >= 8,
  },
  {
    key: "uppercase",
    label: "At least one uppercase letter",
    test: (password: string) => /[A-Z]/.test(password),
  },
  {
    key: "lowercase",
    label: "At least one lowercase letter",
    test: (password: string) => /[a-z]/.test(password),
  },
  {
    key: "number",
    label: "At least one number",
    test: (password: string) => /\d/.test(password),
  },
  {
    key: "symbol",
    label: "At least one symbol",
    test: (password: string) => /[^A-Za-z0-9]/.test(password),
  },
] as const;

export function getPasswordRequirements(password: string) {
  return PASSWORD_REQUIREMENTS.map((requirement) => ({
    ...requirement,
    met: requirement.test(password),
  }));
}

export function isStrongPassword(password: string) {
  return getPasswordRequirements(password).every((requirement) => requirement.met);
}

export function getPasswordRequirementError(password: string) {
  return getPasswordRequirements(password).find((requirement) => !requirement.met)
    ?.label;
}
